<template>
  <div class="sync">
    <el-dialog
      :close-on-click-modal="false"
      title="查看"
      width="1100px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <el-table
      border=""
        :span-method="objectSpanMethod"
        ref="multipleTable"
        :data="orderData"
        class="sync-table"
      >
        <el-table-column label="编号" align="center" width="80">
          <template slot-scope="scope">
            {{ scope.row.index }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="订单号" align="center">
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" align="center">
        </el-table-column>
        <el-table-column prop="sku" label="SKU" align="center">
        </el-table-column>
        <el-table-column prop="quantityPurchased" label="数量" align="center">
        </el-table-column>
        <el-table-column prop="itemPrice" label="价格" align="center">
        </el-table-column>
        <el-table-column prop="itemTax" label="税收" align="center">
        </el-table-column>
        <el-table-column prop="orderStatus" label="订单状态" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure" size="small"> 关闭 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ViewImportOrder",
  data() {
    return {}
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    orderData: {
      type: Array,
      default() {
        return []
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit("onClose")
    },
    sure() {
      this.$emit("onClose")
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.count != 0) {
          return {
            rowspan: row.count,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
       if (columnIndex === 1) {
        if (row.count != 0) {
          return {
            rowspan: row.count,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.sync /deep/.el-table::before {
  display: none;
}
.sync-table {
  overflow-y: auto;
  max-height: 600px;
}
.status {
  margin: 10px 0;
}
.red {
  color: red;
}
.detail-wrap {
  max-height: 180px;
  overflow-y: auto;
}
.detail .list {
  padding: 5px 20px;
  box-sizing: border-box;
  width: 100%;
}
</style>
